import { ChevronRightIcon } from '@radix-ui/react-icons';
import { useThemeContext } from '../../../../contexts/ThemeContext';
import { useScrollToBottom } from '../../../../utils/hooks/useScrollToBottom';
import { PoweredByQITech } from '../components/PoweredByQITech';
import { resolveColor } from '../../theme/utils/resolveColor';
import QITechMono from '../../theme/assets/qi_tech_mono.svg';
import * as S from './styles';

interface PrivatePayrollAuctionRedirectProps {
    clientName: string;
    issueAmount?: number;
}

const formatAmount = (amountInCents: number): string =>
    (amountInCents / 100).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

export const PrivatePayrollAuctionRedirect = ({
    clientName,
    issueAmount,
}: PrivatePayrollAuctionRedirectProps) => {
    const { clientThemeSettings } = useThemeContext();

    const primary = resolveColor('primary', clientThemeSettings);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { contentEndRef, hasScrolledToEnd, scrollToBottom } = useScrollToBottom([]);

    const handleContinue = () => {
        if (!hasScrolledToEnd) { scrollToBottom(); return; }
        window.location.href = window.location.href.replace('/r', '/s');
    };

    return (
        <S.PageWrapper>
            <S.Header>
                <S.HeaderLogo src={QITechMono} alt="logo" />
            </S.Header>

            <S.Content $hasAmount={issueAmount != null}>
                {issueAmount != null ? (
                    <>
                        <S.Headline>Sua proposta de crédito no valor total de</S.Headline>

                        <S.Amount>
                            <S.AmountCurrency>R$</S.AmountCurrency>
                            <S.AmountValue>{formatAmount(issueAmount)}</S.AmountValue>
                        </S.Amount>

                        <S.Headline $small>
                            está <em>pronta para assinatura.</em>
                        </S.Headline>

                        <S.RedirectMessage>
                            Para concluir, você será redirecionado com segurança até o nosso
                            parceiro, <S.PartnerName $color={primary}>{clientName}</S.PartnerName>,
                            para revisar e assinar.
                        </S.RedirectMessage>
                    </>
                ) : (
                    <>
                        <S.Text>
                            Para seguir com o empréstimo da carteira de trabalho digital, você será
                            redirecionado para a tela do nosso parceiro,{' '}
                            <S.PartnerName $color={primary}>{clientName}.</S.PartnerName>
                        </S.Text>

                        <S.SubText>
                            Clique em <strong>continuar</strong> para seguir.
                        </S.SubText>
                    </>
                )}

                <div ref={contentEndRef} />
            </S.Content>

            <S.BottomSection>
                {clientThemeSettings?.logo_url && (
                    <S.PartnerLogo src={clientThemeSettings.logo_url} alt={clientName} />
                )}

                <S.ContinueButton $backgroundColor={primary} onClick={handleContinue}>
                    Continuar
                    <ChevronRightIcon width={24} height={24} />
                </S.ContinueButton>

                <S.PoweredByContainer>
                    <PoweredByQITech />
                </S.PoweredByContainer>
            </S.BottomSection>
        </S.PageWrapper>
    );
};
